import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=04cd6ca8&scoped=true&"
import script from "./identity.vue?vue&type=script&lang=js&"
export * from "./identity.vue?vue&type=script&lang=js&"
import style0 from "./identity.vue?vue&type=style&index=0&lang=less&"
import style1 from "./identity.vue?vue&type=style&index=1&id=04cd6ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd6ca8",
  null
  
)

export default component.exports